<template>
  <wo-card :title="cardTitle">
    <slot name="actions" slot="actions" />
    <slot></slot>
    <template v-if="value">
      <po-maps v-if="modMap && value.coordinates" :center="value.coordinates" :center-label="addressName" :center-message="shortName" :zoom="13" :movable="movable" @move="emitMove"></po-maps>
      <wo-properties v-if="modProps" mod-bordered mod-horizontal>
        <template v-for="(component, i) in components">
          <wo-properties-label :key="component.id"><wo-label v-t="component.labelKey" /></wo-properties-label>
          <wo-properties-value :key="i">
            {{ component.value }}
            <div v-if="component.altValue" v-wo-color.light v-wo-text.xs>{{ component.altValue }}</div>
          </wo-properties-value>
        </template>
      </wo-properties>
    </template>
    <po-empty-state v-else labelKey="address.notSet"/>
  </wo-card>
</template>

<script>

import _ from 'lodash'
import { Address } from '@/model/company'
import { Enums } from '@/model/util'

const enAction = { labelKey: 'address.action.showEnglish' }
const localAction = { labelKey: 'address.action.showLocal' }

const components = [
  Enums.value('streetDisplay', 'address.street'),
  Enums.value('cityDisplay', 'address.city'),
  Enums.value('areaDisplay', 'address.area'),
  Enums.value('country', 'address.country')
]
export default {
  props: {
    value: Address,
    title: String,
    addressName: String,
    movable: Boolean,
    modMap: Boolean,
    modProps: Boolean
  },
  computed: {
    cardTitle () {
      return this.title || this.$t('general.address')
    },
    actions () {
      return [enAction, localAction]
    },
    components () {
      return _.map(components, this.createComponent)
    },
    shortName () {
      return (this.value.localized || this.value).shortName
    }
  },
  methods: {
    createComponent (component) {
      const root = this.value.localized || this.value
      const value = root[component.id]
      const altValue = this.value[component.id]

      return Object.assign({
        value: value,
        altValue: value === altValue ? undefined : altValue
      }, component)
    },
    emitMove (coordinates) {
      this.$emit('move', coordinates)
    }
  }
}
</script>
